'use client'

import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'
import { pushPageViewToDataLayer } from '@/utilities/gtmPageView'

export function GTMPageView(): null {
  const pathname = usePathname()
  const isInitialMount = useRef(true)

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
      return
    }
    pushPageViewToDataLayer(pathname)
  }, [pathname])

  return null
}
